import axios from '@/utils/request'

export default {
    getSiteMapAggregation: data => axios({ url: '/api/product/open/siteMapAggregation', method: 'get', data }),

    siteMapConfigList: params => axios({ url: '/api/product/siteMapConfigList', method: 'get', params }),

    siteMapConfig: data => axios({ url: '/api/product/siteMapConfig', method: 'put', data }),
    seoTitle: params => axios({ url: '/api/product/open/seo/businessId', method: 'get', params }),

    putSeoInfo: data => axios({ url: '/api/product/seo/info', method: 'put', data }),

    getCategory: params => axios({ url: '/api/product/siteMapConfigFirstCategoryList', method: 'get', params })



    

    

}